import React, { useEffect, useRef, useState } from "react";
import SelectBox from "../../../../components/elements/form/selectBox";
import { useSpearPartsApi } from "../../../../store/api/hooks/spearPartsApiHook";
import { useCommonApi } from "../../../../store/api/hooks/commonApiHook";
import { useAssetsApi } from "../../../../store/api/hooks/assetsApiHook";
import Currency from "../../../../components/currency";

interface CreatePurchasedRequestAssetsProps {
    data?: any;
    savedtax?: any;
    onUpdate?: (data: Array<any>) => void;
    onSetTax?: (tax: any) => void;
}
const CreatePurchaseOrderAssets: React.FC<CreatePurchasedRequestAssetsProps> = ({ data, savedtax = null, onUpdate = (data: Array<any>) => { }, onSetTax }) => {
    const divRef = useRef<any>(null);
    const sparePartsAPI = useSpearPartsApi();
    const commonApi: any = useCommonApi();
    const assetsApi: any = useAssetsApi();

    const blankpartmodel = {
        assetID: null,
        assetName: null,
        vendorID: null,
        vendorName: ``,
        unitID: 5,
        unitCode: `Each`,
        requiredQty: 0,
        purchaseCost: 0,
        totalAmount: 0,
        isEdit: false
    };

    const [showSuggestion, setShowSuggestion] = useState<boolean>(false);
    const [assetItems, setAssetItems] = useState<any[]>(data || []);
    const [lastSearchAssets, setLastSearchAssets] = useState([]);
    const [assetSuggestions, setAssetSuggestions] = useState<any[]>([]);
    const [vendorList, setVendorList] = useState<any[]>([]);
    const [highlightedIndex, setHighlightedIndex] = useState(-1);

    const [taxes, setTaxes] = useState<any[]>([]);
    const [tax, setTax] = useState<any>(null);

    const getTaxes = async () => {
        return new Promise((resolve, reject) => {
            commonApi.getTaxes({}, (resp: any) => {
                const taxesList = resp.taxRates.map((tax: any) => ({
                    label: tax.taxRateName,
                    value: tax.taxRateID,
                    rate: tax.taxRate,
                }));
                setTaxes(taxesList);
                if (!savedtax)
                    setTax(taxesList[0] || null);
                resolve(resp.taxRates);
            }, (error: any) => {
                reject([]);
            });
        });
    };

    const onOutsideClick = () => {
        handleOnClickCellEdit()
        setShowSuggestion(false);
    }

    const handleOnClickCellEdit = (identifier: string = ``, e: any = null) => {
        if (identifier) {
            const cellElement = document.querySelector(`#${identifier}`) as HTMLDivElement;
            const previewElement = cellElement.querySelector(`.preview-value`) as HTMLDivElement;
            const editElement = cellElement.querySelector(`.edit-value`) as HTMLDivElement;
            if (previewElement && editElement) {
                if (cellElement.id === `${identifier}`) {
                    if (!previewElement.classList.contains(`hidden`)) previewElement.classList.add(`hidden`);
                    if (editElement.classList.contains(`hidden`)) editElement.classList.remove(`hidden`);
                }
            }
        }

        //resetOthersCellEditState(`part-item-name-${index}`);
        const editableList = document.querySelectorAll(`.editable`) as NodeListOf<HTMLDivElement>
        //console.log("editableList", editableList);
        for (let i = 0; i < editableList.length; i++) {
            const editableCell = editableList[i];
            const preview = editableCell.querySelector(`.preview-value`) as HTMLDivElement;
            const edit = editableCell.querySelector(`.edit-value`) as HTMLDivElement;
            if (editableCell.id !== `${identifier}`) {
                if (preview?.classList.contains(`hidden`)) preview?.classList.remove(`hidden`);
                if (!edit?.classList.contains(`hidden`)) edit?.classList.add(`hidden`);
            }
        }
    };

    const handleAssetsSearch = async (inputval: any) => {
        if (inputval && (`` + inputval).length > 2) {
            const assetsrespp: any = await new Promise((resolve, reject) => {
                assetsApi.getAssetsList({
                    pageSize: 10,
                    pageNumber: 1,
                    searchParam: inputval,
                    statusIDs: [1, 2, 3, 4, 5, 6].join(`,`)
                }, (resp: any) => {
                    if (resp && resp.code === 200 && resp.successful === true && resp.hasOwnProperty(`assetList`) && Array.isArray(resp.assetList) && resp.assetList.length > 0) {
                        const bindAssets = resp.assetList.map((asset: any) => {
                            return {
                                value: asset.name,
                                label: asset.name,
                                data: asset
                            };
                        });
                        setLastSearchAssets(resp.assetList);
                        resolve(bindAssets);
                    } else {
                        resolve([]);
                    }
                }, (error: any) => {
                    reject([])
                })
            });
            if (assetsrespp.length > 0) {
                setShowSuggestion(true);
            } else {
                setShowSuggestion(false);
            }
            setAssetSuggestions(assetsrespp);
        } else {
            setAssetSuggestions([]);
            setShowSuggestion(false);
        }
    };

    /* const handleAssetsSearchDropdown = async (inputval: any): Promise<any[]> => {
        return new Promise((resolve, reject) => {
            assetsApi.getAssetsList({
                pageSize: 10,
                pageNumber: 1,
                searchParam: inputval,
                statusIDs: [1, 2, 3, 4, 5, 6].join(`,`)
            }, (resp: any) => {
                if (resp && resp.code === 200 && resp.successful === true && resp.hasOwnProperty(`assetList`) && Array.isArray(resp.assetList) && resp.assetList.length > 0) {
                    const bindAssets = resp.assetList ? resp.assetList.map((asset: any) => {
                        return {
                            value: asset.assetID,
                            label: asset.name,
                        };
                    }) : [];
                    setLastSearchAssets(resp.assetList);
                    resolve(bindAssets);
                } else {
                    resolve([]);
                }
            }, (error: any) => {
                reject([])
            })
        });
    }; */


    /* const handleAssetsSearchDropdown = async (inputval: any): Promise<any[]> => {
        return new Promise((resolve, reject) => {
            assetsApi.getAssetNameByParam({
                searchParam: inputval,
            }, (resp: any) => {
                if (resp && resp.code === 200 && resp.successful === true && resp.hasOwnProperty(`assetList`) && Array.isArray(resp.assetList) && resp.assetList.length > 0) {
                    const bindAssets = resp.assetList ? resp.assetList.map((asset: any) => {
                        return {
                            value: asset.name,
                            label: asset.name,
                        };
                    }) : [];
                    setLastSearchAssets(resp.assetList);
                    
                    // Check if the input value already exists in the results
                    const inputExists = bindAssets.some((asset: any) => 
                        asset.value.toLowerCase() === inputval.toLowerCase()
                    );
                    
                    // If input doesn't exist and has value, add it as a custom option
                    if (!inputExists && inputval && inputval.trim().length > 0) {
                        bindAssets.unshift({
                            value: inputval.trim(),
                            label: inputval.trim(),
                        });
                    }
                    
                    resolve(bindAssets);
                } else {
                    // If no results from API but user has typed something, allow it as custom input
                    if (inputval && inputval.trim().length > 0) {
                        resolve([{
                            value: inputval.trim(),
                            label: inputval.trim(),
                        }]);
                    } else {
                        resolve([]);
                    }
                }
            }, (error: any) => {
                // On error, still allow custom input if user has typed something
                if (inputval && inputval.trim().length > 0) {
                    resolve([{
                        value: inputval.trim(),
                        label: inputval.trim(),
                    }]);
                } else {
                    reject([]);
                }
            })
        });
    }; */

    const handleVendorSearch = async (inputval: any): Promise<any[]> => {
        return new Promise((resolve, reject) => {
            commonApi.GetServiceprovidertList({}, (resp: any) => {
                if (resp && resp.hasOwnProperty(`vendorList`) && Array.isArray(resp.vendorList) && resp.vendorList.length > 0) {
                    resolve(resp.vendorList);
                } else {
                    resolve([]);
                }
            }, (error: any) => {
                reject([])
            })
        });
    };

    const handleKeyDown = (e: any, keyindex: number) => {
        if (!showSuggestion) return;
        switch (e.key) {
            case 'ArrowDown':
                setHighlightedIndex((prev) => prev < assetSuggestions.length - 1 ? prev + 1 : 0);
                break;
            case 'ArrowUp':
                setHighlightedIndex((prev) => prev > 0 ? prev - 1 : assetSuggestions.length - 1);
                break;
            case 'Enter':
                if (highlightedIndex >= 0) {
                    const updatedAssets = [...assetItems];
                    updatedAssets[keyindex].assetName = assetSuggestions[highlightedIndex].label;
                    setAssetItems(updatedAssets);
                    onUpdate(updatedAssets);
                    setShowSuggestion(false);
                }
                break;
            default:
                break;
        }
    }

    const init_page_data = async () => {
        const vendorlist = await handleVendorSearch(``);
        setVendorList(vendorlist);
    };

    useEffect(() => {
        // set dummy data
        getTaxes();
        init_page_data();
        setTax(savedtax || null);
    }, []);

    useEffect(() => {
        const handleClickOutside = (event: any) => {
            if (divRef.current && !divRef.current.contains(event.target)) {
                onOutsideClick();
            }
        };
        document.addEventListener('mousedown', handleClickOutside);
        return () => {
            document.removeEventListener('mousedown', handleClickOutside);
        };
    }, [onOutsideClick]);

    useEffect(() => {
        const handleKeyDown = (event: any) => {
            if (event.key === 'Escape') {
                onOutsideClick();
            }
        };
        window.addEventListener('keydown', handleKeyDown);
        return () => {
            window.removeEventListener('keydown', handleKeyDown);
        };
    }, [onOutsideClick]);


    const getSubTotal = () => {
        return assetItems.reduce((total, item) => {
            const itemCost = parseFloat(item.purchaseCost) || 0;
            const itemQuantity = parseFloat(item.requiredQty) || 0;
            return total + itemCost * itemQuantity;
        }, 0).toFixed(2);
    };
    const getTotal = () => {
        const subTotal = Number(getSubTotal());
        console.log("Sub tax is", tax);
        const taxRate = subTotal * (tax?.rate || 0) / 100;

        return (subTotal + taxRate).toFixed(2);
    };

    useEffect(() => {
        if (onSetTax) {
            onSetTax(tax);
            getTotal();
            console.log("Tax is ", tax);
        }
    }, [tax, onSetTax]);

    return (
        <div>
            <div className="flex justify-between items-center mt-1">
                <h4 className='font-semibold text-[0.938rem] py-4 uppercase'>ITEMS</h4>
                <button type={`button`} className='text-primary' onClick={() => {
                    const newAsset = Object.assign({}, JSON.parse(JSON.stringify(blankpartmodel)));
                    setAssetItems([...assetItems, newAsset]);
                    onUpdate([...assetItems, newAsset]);
                }}>Add asset</button>
            </div>
            {/* total width 849px */}
            <div className={`border border-[#043E6133] rounded-[5px] parts-table`}>
                <div className={`flex items-center flex-nowrap bg-[#F0F0F0] rounded-ss-[5px] rounded-se-[5px]`}>
                    <div className={`w-[302px] flex-shrink-0 grow font-semibold text-[#262A2D] text-[13px] px-2.5 py-2 h-[50px] flex items-center`}>Item Name</div> {/* 302px */}
                    <div className={`w-[160px] flex-shrink-0 font-semibold text-[#262A2D] text-[13px] px-2.5 py-2 h-[50px] flex items-center justify-end`}>Cost</div> {/* 256px */}
                    <div className={`w-[160px] flex-shrink-0 font-semibold text-[#262A2D] text-[13px] px-2.5 py-2 h-[50px] flex items-center justify-end`}>Quantity</div> {/* 256px */}
                    <div className={`w-[160px] flex-shrink-0 font-semibold text-[#262A2D] text-[13px] px-2.5 py-2 h-[50px] flex items-center justify-end`}>Total</div> {/* 256px */}
                    <div className={`w-[32px] flex-shrink-0 font-semibold text-[#262A2D] text-[13px] px-0 py-2 h-[50px] flex items-center`}> </div> {/* 32px */}
                </div>
                <div className={``} ref={divRef}>
                    {assetItems.length === 0 && (
                        <div className={`flex items-center justify-center h-24 text-gray-500`}>
                            No assets added yet.
                        </div>
                    )}
                    {assetItems.map((asset, index) => (
                        <div className={`flex items-center flex-nowrap border-b border-[#043E6133]`} key={`asset-item-${index}`}>
                            <div className={`w-[302px] flex-shrink-0 grow font-normal text-[#42484B] text-[15px] px-2.5 min-h-12 max-h-12 flex justify-center flex-col cursor-pointer editable`} id={`asset-item-name-${index}`} onClick={(e: any) => {
                                handleOnClickCellEdit(`asset-item-name-${index}`, e);
                                e.stopPropagation();
                                e.preventDefault();
                            }}>
                                <div className={`preview-value line-clamp-1`} title={asset.assetName ? asset.assetName : `Click here to add data`}>{asset.assetName || `--`}</div>
                                <div className={`edit-value hidden relative`}>
                                    {/* <SelectBox
                                        label={``}
                                        value={asset && asset?.assetName ? { label: asset.assetName, value: asset.assetID } : null}
                                        onChange={(value: any) => {
                                            if (value) {
                                                const updatedAssets = [...assetItems];
                                                updatedAssets[index].assetName = value?.label || ``;
                                                updatedAssets[index].assetID = value?.value || null;
                                                const cronologicalAsset: any = lastSearchAssets.find((a: any) => a.assetID === +value?.value);
                                                console.log(`cronologicalAsset`, cronologicalAsset);                                            
                                                updatedAssets[index].purchaseCost = cronologicalAsset.purchaseCost || 0;
                                                updatedAssets[index].vendorID = cronologicalAsset.vendorID || 0;
                                                setAssetItems(updatedAssets);
                                                onUpdate(updatedAssets);
                                            } else {
                                                const updatedAssets = [...assetItems];
                                                updatedAssets[index].assetName = ``;
                                                updatedAssets[index].assetID = null;
                                                updatedAssets[index].purchaseCost = 0;
                                                updatedAssets[index].vendorID = null;
                                                setAssetItems(updatedAssets);
                                                onUpdate(updatedAssets);
                                            }
                                        }}
                                        required
                                        placeholder='Search & Select Part'
                                        options={[]}
                                        className={`!my-0`}
                                        customStyleOption={{ control: (base) => ({ ...base, marginTop: `0rem`, minHeight: '32px' }) }}
                                        async={true}
                                        isClearable={true}
                                        asyncLoadOptions={async (inputValue: string) => {
                                            return handleAssetsSearchDropdown(inputValue);
                                        }}
                                    /> */}
                                    
                                    <input
                                        type="text"
                                        className={`w-full border border-gray-300 rounded px-2 py-1 outline-none`}
                                        value={asset.assetName || ``}
                                        placeholder={`Enter Asset Name`}
                                        id={`asset-item-name-input-${index}`}
                                        autoComplete={ `off` }
                                        onChange={(e) => {
                                            const keywords = e.target.value;
                                            const updatedAssets = [...assetItems];
                                            updatedAssets[index].assetName = keywords;
                                            updatedAssets[index].purchaseCost = 0;
                                            updatedAssets[index].vendorID = 0;
                                            setAssetItems(updatedAssets);
                                            onUpdate(updatedAssets);
                                            handleAssetsSearch(keywords);
                                                                                                                                  
                                        }}
                                        onKeyDown={(e) => {
                                            handleKeyDown(e, index)
                                        }}
                                    />
                                    { showSuggestion && assetSuggestions.length > 0 && (
                                        <div className={ `autosuggestion-box max-h-60 overflow-y-auto bg-white shadow-lg absolute top-8 z-10 border border-[#F0F0F0]  w-full` }>
                                            {assetSuggestions.map((suggestion: any, sindex:number) => (
                                                <div key={ `asset-suggestion-${sindex}` } className={`autosuggestion-item px-2 py-2 border-b border-[#F0F0F0] hover:bg-slate-100 ${sindex === highlightedIndex ? 'bg-slate-100' : ''}`} onClick={() => {           
                                                    console.log(`Selected suggestion:`, suggestion);
                                                    const updatedAssets = [...assetItems];
                                                    updatedAssets[index].assetName = suggestion.label;
                                                    updatedAssets[index].purchaseCost = suggestion.data.purchaseCost || 0;
                                                    updatedAssets[index].vendorID = suggestion.data.vendorID || 0;
                                                    setAssetItems(updatedAssets);
                                                    onUpdate(updatedAssets);
                                                    setShowSuggestion(false);
                                                }}>
                                                    {suggestion.label}
                                                </div>
                                            ))}                                            
                                        </div>
                                    )}
                                   
                                </div>
                            </div>
                            <div className={`w-[160px] flex-shrink-0 font-normal text-[#42484B] text-[15px] px-2.5 py-3 min-h-12 max-h-12 flex justify-center flex-col cursor-pointer editable`} id={`part-item-uniPrice-${index}`} onClick={(e: any) => {
                                handleOnClickCellEdit(`part-item-uniPrice-${index}`, e);
                                e.stopPropagation();
                                e.preventDefault();
                            }}>
                                <div className={`preview-value text-right line-clamp-1`} ><Currency currency={`USD`} value={Number(asset.purchaseCost) || 0} /></div>
                                <div className={`edit-value hidden`}>
                                    <div className={`flex`}>
                                        <span className={`border border-gray-300 bg-gray-50 rounded-tl rounded-bl flex items-center justify-center px-2 py-1 border-r-0`}>$</span>
                                        <input
                                            type="number"
                                            name={`poassetcost${index}`}
                                            className={`w-full border border-gray-300 rounded-tr rounded-br px-2 py-1 outline-none text-right input-no-spinner`}
                                            value={asset.purchaseCost}
                                            min={0}
                                            onInput={(e: any) => {
                                                const newQty = e.target.value;
                                                const updatedAssets = [...assetItems];
                                                //console.log(e.target.value);                                                                                                
                                                //console.log(newQty);
                                                updatedAssets[index].purchaseCost = newQty;
                                                setAssetItems(updatedAssets);
                                                onUpdate(updatedAssets);
                                            }}
                                            onBlur={(e: any) => {
                                                const newQty = e.target.value;
                                                const updatedAssets = [...assetItems];
                                                updatedAssets[index].purchaseCost = isNaN(newQty) ? 0 : (+newQty > -1 ? +newQty : 0);
                                                setAssetItems(updatedAssets);
                                                onUpdate(updatedAssets);
                                            }}
                                        /*
                                        onChange={(e) => {
                                            const newQty = +e.target.value;
                                            const updatedAssets = [...assetItems];
                                            updatedAssets[index].purchaseCost = isNaN(newQty) ? 0 : newQty;
                                            setAssetItems(updatedAssets);
                                            onUpdate(updatedAssets);
                                        }}*/
                                        />
                                    </div>
                                </div>
                            </div>
                            <div className={`w-[160px] flex-shrink-0 font-normal text-[#42484B] text-[15px] px-2.5 py-3 min-h-12 max-h-12 flex justify-center flex-col cursor-pointer editable`} id={`part-item-qty-${index}`} onClick={(e: any) => {
                                handleOnClickCellEdit(`part-item-qty-${index}`, e);
                                e.stopPropagation();
                                e.preventDefault();
                            }}>
                                <div className={`flex items-center gap-1 flex-nowrap justify-end`}>
                                    <div className={`w-20 min-w-20 text-right`}>
                                        <div className={`preview-value`} title={+asset.requiredQty > 0 ? (asset.requiredQty + ` Each`) : `Click here to add data`}>{asset.requiredQty || 0}</div>
                                        <div className={`edit-value hidden`}>
                                            <input
                                                type="tel"
                                                className={`w-full border border-gray-300 rounded px-2 py-1 outline-none text-right`}
                                                value={asset.requiredQty}
                                                onChange={(e) => {
                                                    const newQty = +e.target.value;
                                                    const updatedAssets = [...assetItems];
                                                    updatedAssets[index].requiredQty = isNaN(newQty) ? 0 : newQty;
                                                    updatedAssets[index].totalAmount = updatedAssets[index].requiredQty * updatedAssets[index].purchaseCost;
                                                    setAssetItems(updatedAssets);
                                                    onUpdate(updatedAssets);
                                                }}
                                            />
                                        </div>
                                    </div>
                                    <div>{asset.unitCode || ``}</div>
                                </div>
                            </div>
                            <div className={`w-[160px] flex-shrink-0 font-normal text-[#42484B] text-[15px] px-2.5 py-3 min-h-12 max-h-12 flex justify-center bg-[#F9F9F9] flex-col editable cursor-pointer`} id={`part-item-qty-${index}`} >
                                <div className={`flex items-center gap-1 flex-nowrap justify-end`}>
                                    <div><Currency currency={`USD`} value={Number((asset?.purchaseCost * (asset?.requiredQty || 0))?.toFixed(2) || 0)} /></div>
                                </div>
                            </div>
                            <div className={`w-8 min-w-8 font-normal text-[#42484B] text-[15px] px-2.5 py-3`}>
                                <a onClick={() => {
                                    const updatedAssets = [...assetItems];
                                    updatedAssets.splice(index, 1);
                                    setAssetItems(updatedAssets);
                                    onUpdate(updatedAssets);
                                }}>
                                    <svg width="15" height="16" viewBox="0 0 15 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                                        <rect y="0.500977" width="15.0008" height="15" rx="7.5" fill="#E6BDCB" />
                                        <path d="M10.8974 10.9032C10.93 10.9357 10.9557 10.9743 10.9733 11.0168C10.9909 11.0593 11 11.1048 11 11.1508C11 11.1968 10.9909 11.2423 10.9733 11.2848C10.9557 11.3273 10.93 11.3659 10.8974 11.3984C10.8649 11.4309 10.8263 11.4567 10.7838 11.4743C10.7413 11.4919 10.6958 11.501 10.6498 11.501C10.6038 11.501 10.5583 11.4919 10.5158 11.4743C10.4733 11.4567 10.4347 11.4309 10.4022 11.3984L7.5 8.49576L4.59779 11.3984C4.53212 11.4641 4.44305 11.501 4.35018 11.501C4.2573 11.501 4.16823 11.4641 4.10256 11.3984C4.03689 11.3327 4 11.2437 4 11.1508C4 11.0579 4.03689 10.9689 4.10256 10.9032L7.00521 8.00098L4.10256 5.09876C4.03689 5.03309 4 4.94402 4 4.85115C4 4.75828 4.03689 4.66921 4.10256 4.60354C4.16823 4.53787 4.2573 4.50098 4.35018 4.50098C4.44305 4.50098 4.53212 4.53787 4.59779 4.60354L7.5 7.50619L10.4022 4.60354C10.4679 4.53787 10.557 4.50098 10.6498 4.50098C10.7427 4.50098 10.8318 4.53787 10.8974 4.60354C10.9631 4.66921 11 4.75828 11 4.85115C11 4.94402 10.9631 5.03309 10.8974 5.09876L7.99478 8.00098L10.8974 10.9032Z" fill="#F31260" />
                                    </svg>
                                </a>
                            </div>
                        </div>
                    ))}
                    {assetItems.length != 0 && (
                        <>
                            <div className={`flex items-center flex-nowrap border-b border-[#043E6133]`} >
                                <div className={`w-[622px] flex-shrink-0 grow font-normal text-[#42484B] text-[15px] px-2.5 min-h-12 max-h-12 flex justify-center flex-col cursor-pointer editable`} >
                                    <div className={`preview-value line-clamp-1`} >Sub Total</div>
                                </div>

                                <div className={`w-[160px] flex-shrink-0 font-normal text-[#42484B] text-[15px] px-2.5 py-3 min-h-12 max-h-12 flex justify-center flex-col editable cursor-pointer`} >
                                    <div className={`flex items-center gap-1 flex-nowrap justify-end`}>
                                        <div>
                                            <Currency currency={`USD`} value={getSubTotal()} />
                                        </div>
                                    </div>
                                </div>
                                <div className={`w-8 min-w-8 font-normal text-[#42484B] text-[15px] px-2.5 py-3`}></div>
                            </div>
                            <div className={`flex items-center flex-nowrap border-b border-[#043E6133]`} >
                                <div className={`w-[622px] flex-shrink-0 grow font-normal text-[#42484B] text-[15px] px-2.5 min-h-12 max-h-12 flex justify-center flex-col cursor-pointer editable`} >
                                    <div className={`preview-value line-clamp-1`} >Tax</div>
                                </div>

                                <div className={`w-[160px] flex-shrink-0 font-normal text-[#42484B] text-[15px] px-2.5 py-3 min-h-12 max-h-12 flex justify-center flex-col editable cursor-pointer`} >
                                    <div className={`flex items-center gap-1 flex-nowrap justify-end`}>
                                        <div>
                                            <SelectBox
                                                defaultValue={tax}
                                                value={tax}
                                                onChange={setTax}
                                                placeholder="Choose Tax"
                                                className="!my-2"
                                                options={taxes}
                                                size="sm"
                                            />
                                        </div>
                                    </div>
                                </div>
                                <div className={`w-8 min-w-8 font-normal text-[#42484B] text-[15px] px-2.5 py-3`}></div>
                            </div>
                            <div className={`flex items-center flex-nowrap`} >
                                <div className={`w-[622px] flex-shrink-0 grow font-normal text-[#42484B] text-[15px] px-2.5 min-h-12 max-h-12 flex justify-center flex-col cursor-pointer editable`} >
                                    <div className={`preview-value line-clamp-1 font-semibold`} >Total</div>
                                </div>

                                <div className={`w-[160px] flex-shrink-0 font-normal text-[#42484B] text-[15px] px-2.5 py-3 min-h-12 max-h-12 flex justify-center flex-col editable cursor-pointer`} >
                                    <div className={`flex items-center gap-1 flex-nowrap justify-end`}>
                                        <div><Currency currency={`USD`} value={getTotal()} /></div>
                                    </div>
                                </div>
                                <div className={`w-8 min-w-8 font-normal text-[#42484B] text-[15px] px-2.5 py-3`}></div>
                            </div>
                        </>
                    )}

                </div>
            </div>

        </div>
    );
};
export default CreatePurchaseOrderAssets;